import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImageGalleryBlock1 } from "./ImageGalleryBlock1";
import { ImageGalleryBlock2 } from "./ImageGalleryBlock2";
import { ImageGalleryBlock3 } from "./ImageGalleryBlock3";

export const galleryBlocks: BlockExportMapping = {
  ImageGalleryBlock1,
  ImageGalleryBlock2,
  ImageGalleryBlock3,
};
